import React, { useEffect } from 'react';
import { FaEdit, FaTrash, FaExternalLinkAlt, FaSync } from 'react-icons/fa';

const ContextMenu = ({ x, y, onClose, onEdit, onDelete, onOpen, item }) => {
  // Close menu when clicking elsewhere
  useEffect(() => {
    const handleClick = () => onClose();
    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, [onClose]);

  return (
    <div 
      className="fixed z-[200] bg-white border border-slate-200 shadow-2xl rounded-2xl py-2 w-48 overflow-hidden"
      style={{ top: y, left: x }}
      onClick={(e) => e.stopPropagation()} // Prevent accidental folder triggers
    >
      <div className="px-4 py-2 mb-1 border-b border-slate-50">
        <p className="text-[10px] font-black text-slate-400 uppercase truncate">
          {item?.programName || 'Options'}
        </p>
      </div>

      <button 
        onClick={() => { onOpen(item); onClose(); }}
        className="w-full px-4 py-2.5 flex items-center gap-3 text-xs font-bold text-slate-700 hover:bg-purple-50 hover:text-purple-600 transition-colors"
      >
        <FaExternalLinkAlt className="text-slate-300" /> Open Folder
      </button>

      <button 
        onClick={() => { onEdit(item); onClose(); }}
        className="w-full px-4 py-2.5 flex items-center gap-3 text-xs font-bold text-slate-700 hover:bg-purple-50 hover:text-purple-600 transition-colors"
      >
        <FaEdit className="text-slate-300" /> Edit Metadata
      </button>

      <button 
        onClick={() => { /* Logic for manual sync */ onClose(); }}
        className="w-full px-4 py-2.5 flex items-center gap-3 text-xs font-bold text-slate-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
      >
        <FaSync className="text-slate-300" /> Force Sync
      </button>

      <hr className="my-1 border-slate-50" />

      <button 
        onClick={() => { if(window.confirm('Delete this program and all associated files?')) onDelete(item.id); onClose(); }}
        className="w-full px-4 py-2.5 flex items-center gap-3 text-xs font-bold text-red-500 hover:bg-red-50 transition-colors"
      >
        <FaTrash className="text-red-300" /> Delete Program
      </button>
    </div>
  );
};

export default ContextMenu;